export const TypeMarket = {
    GOLD_BAR: "GoldBar",
    QR: "QrCode"
}

export const defaultRewardItems = {
    points: 1,
    maxPerUser: 1,
};